import type { SubscriberDetails, TransferSignatureResponse } from "@/.generated/hey/backoffice-backend/types.gen";
import type { SubscriberDetailsModel, TransferSignatureModel } from "@/domains/voltacall/voltacall.types";

export function mapVoltacallSubscriberDetails(details: SubscriberDetails): SubscriberDetailsModel {
  return {
    firstName: details.firstName ?? undefined,
    lastName: details.lastName ?? undefined,
    email: details.email ?? undefined,
    phoneNumber: details.phoneNumber ?? undefined,
    hasDeliveryPoint: details.hasDeliveryPoint ?? false,
    isLastSignatureBasic: details.isLastSignatureBasic ?? undefined,
  };
}

export function mapVoltacallTransferSignatureResponse(response: TransferSignatureResponse): TransferSignatureModel {
  return {
    signatureUrl: response.signatureUrl,
  };
}
